require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-health-wellness-at-yarrabend.json") })
        }
      }, "path---news-health-wellness-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-health-wellness-at-yarrabend!./.cache/json/news-health-wellness-at-yarrabend.json
// module id = 819
// module chunks = 231608221292675